import { RefObject, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import PhArrowUpBoldSvg from "../../../assets/svg-fc/PhArrowUpBoldSvg";
import { UI_TOKENS } from "../../../constants/designTokens";

const SHOW_AFTER = 400;

const ScrollToTopButton = ({ containerRef }: { containerRef: RefObject<HTMLElement | null> }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;
    const onScroll = () => setVisible(container.scrollTop > SHOW_AFTER);
    onScroll();
    container.addEventListener("scroll", onScroll, { passive: true });
    return () => container.removeEventListener("scroll", onScroll);
  }, [containerRef]);

  if (!visible) return null;

  return (
    <Box
      component="button"
      type="button"
      aria-label="Scroll to top"
      title="Scroll to top"
      onClick={() => containerRef.current?.scrollTo({ top: 0, behavior: "smooth" })}
      sx={{
        position: "fixed",
        right: { xs: 16, md: 32 },
        bottom: { xs: 16, md: 32 },
        zIndex: 20,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 44,
        height: 44,
        padding: 0,
        border: `1px solid ${UI_TOKENS.borderDefault}`,
        borderRadius: "50%",
        bgcolor: "#fff",
        color: UI_TOKENS.textStrong,
        boxShadow: "0 8px 24px rgba(34,3,31,0.12)",
        cursor: "pointer",
        "&:hover": { bgcolor: "#F6F6F6" },
      }}
    >
      <PhArrowUpBoldSvg size={18} />
    </Box>
  );
};

export default ScrollToTopButton;
